exports.isProduction = process.env.NODE_ENV === "production";

/**
 * polishedDomain
 * Polish the domain
 * @param {String} domain
 */
exports.polishedDomain = (domain, fallbackDomain = "gamedistribution.com") => {
  try {
    if (!domain || domain === "undefined") return fallbackDomain;

    // Remove scheme (http://, https://, etc.)
    domain = domain.replace(/^(https?:\/\/)?/i, "");

    // Remove www. from the beginning if it exists
    domain = domain.replace(/^www\./i, "");

    // Remove path and query parameters
    domain = domain.replace(/\/.*$/, "").replace(/\?.*$/, "");

    return domain;
  } catch (err) {
    console.log(err.message);
    // if there is something wrong with the url,
    // use gamedistribution.com as fallback url
    return fallbackDomain;
  }
};

/**
 * polishedPictureUrl
 * polish picture and apply https if needed
 * @param {String} domain
 */
exports.polishedPictureUrl = picture => {
  const { ASSET_URL } = require("../../config/index");

  // Default picture
  if (!picture) return `${ASSET_URL}/avatar/01.png`;

  // We're replacing old system default avatar with new one on s3
  if (picture && picture.indexOf("assets/img/avatars/") > -1)
    return `${ASSET_URL}/avatar/01.png`;

  if (picture.substring(0, 2) === "//")
    return `https://${picture.substring(2)}`;

  if (picture.substring(0, 5) !== "https" && picture.substring(0, 4) !== "http")
    return `https://${picture}`;

  if (picture.substring(0, 7) === "http://")
    return `https://${picture.substring(7)}`;

  return picture;
};

/**
 * appendQueryParam
 * Append a new query param to the url
 * @param {String} url
 * @param {String} key
 * @param {*} value
 */
exports.appendQueryParam = (url, key, value) => {
  const link = new URL(url);
  link.searchParams.append(key, value);
  return link.href;
};

/**
 * appendObjectAsQueryParam
 * Appends all key & values of the given object to the url as query params
 * @param {String} url
 * @param {Object} obj
 */
exports.appendObjectAsQueryParam = (url, obj) => {
  if (!obj) return url;

  const link = new URL(url);
  Object.keys(obj).forEach(element => {
    link.searchParams.append(element, obj[element]);
  });
  return link.href;
};

/**
 * setLocaleStorageItem
 * Sets item value with an expire date
 * @param {*} key
 * @param {*} value
 * @param {Date} expire
 */
exports.setLocaleStorageItem = (key, value, expire) => {
  window.localStorage.setItem(
    key,
    JSON.stringify({
      value: value,
      expire: expire.getTime()
    })
  );
};

/**
 * getLocaleStorageItem
 * Deletes it if expired, otherwise return the value
 * @param {*} key
 */
exports.getLocaleStorageItem = key => {
  const item = JSON.parse(window.localStorage.getItem(key));
  if (item && item.expire) {
    const isExpired = item.expire < new Date().getTime();
    if (!isExpired) return JSON.parse(item.value);

    // Delete item if it is already expired
    window.localStorage.removeItem(key);
    return null;
  }

  return null;
};

/**
 * generateQueryParamsFromObject
 * Genereates query params from the given object
 * @param {*} obj
 */
exports.generateQueryParamsFromObject = obj => {
  let params = "";
  Object.keys(obj).forEach(el => {
    if (el && obj[el] !== undefined) params += `${el}=${obj[el]}&`;
  });
  return params.substring(0, params.length - 1);
};

/**
 * formatDate
 * Genereates formatted date string
 * @param {*} obj
 */
exports.formatTimestampToDate = (timestamp, format) => {
  const moment = require("moment");
  return moment.unix(timestamp).format(format);
};

/**
 * loadScript
 * Injects the javascript from url into the main head
 * @param {*} text
 */
exports.loadScript = url => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.onload = () => resolve();
    script.onerror = err => reject(err);
    script.src = url;
    document.head.appendChild(script);
  });
};

/**
 * createScript
 * Create the javascript from text into the main head
 * @param {*} text
 */
exports.createScript = text => {
  const script = document.createElement("script");
  script.text = text;
  document.head.appendChild(script);
};

/**
 * getKeyOfValue
 * Gets the object key of the value
 * @param {*} obj
 * @param {*} value
 */
exports.getKeyOfValue = (obj, value) =>
  Object.keys(obj).find(key => obj[key] === value);

/**
 * initFacebookSdk
 * Initializes the facebook sdk for our login & register
 * @param {String} locale
 */
exports.initFacebookSdk = locale => {
  const { FACEBOOK_APP_ID } = require("../../config/index");

  return new Promise(resolve => {
    if (typeof FB !== "undefined") resolve();
    // wait for facebook sdk to initialize before starting the vue app
    window.fbAsyncInit = function() {
      // eslint-disable-next-line no-undef
      FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v8.0"
      });

      resolve();

      // auto authenticate with the api if already logged in with facebook
      // eslint-disable-next-line no-undef
      // FB.getLoginStatus(({ authResponse }) => {
      //   if (authResponse) {
      //     // accountService
      //     //   .apiAuthenticate(authResponse.accessToken)
      //     //   .then(resolve);
      //     resolve();
      //   } else {
      //     resolve();
      //   }
      // });
    };

    // load facebook sdk script
    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = `https://connect.facebook.net/${locale}/sdk.js`;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};

exports.testBanner = `<!--plinga.de -->
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans">
<style>
  .banner,
  .banner-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .banner-box {
    flex: 3 1 30ch;
    height: calc(282px + 5vw);
    overflow: hidden;
  }

  .banner-box img {
    max-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 50%;
    object-position: 50% 50%;
  }

  .banner {
    overflow: hidden;
  }

  .banner-content {
    padding: 16px 32px;
    flex: 4 1 40ch;
  }

  .banner-tags {
    margin: 0 -8px;
  }

  .banner-tag {
    display: inline-block;
    margin: 8px;
    font-size: 0.875em;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--primary);
  }

  .banner-title {
    margin: 0;
    font-size: clamp(1.4em, 2.1vw, 2.1em);
    font-family: "Open Sans";
  }

  .banner-title a {
    text-decoration: none;
    color: inherit;
  }

  .banner-shop-button {
    display: flex;
    align-items: center;
    padding: 12px 20px 12px 18px;
    border-radius: 4px;
    border: 2px solid currentColor;
    color: var(--primary);
    background: none;
    cursor: pointer;
    font-weight: bold;
    margin: auto;
  }

  .banner-close-button {
    display: flex;
    align-self: flex-start;
    cursor: pointer;
    width: 42px;
    height: 42px;
    background-image: url(https://i.ibb.co/Ph0ZsLc/Close-Button.png);
    z-index: 9999;
    margin: 5px;
    position: absolute;
    right: 0;
  }

  /* Body Layout */
  * {
    box-sizing: border-box;
  }

  .card {
    // width: clamp(320px, 65%, 65%);
    // padding: 24px;
    opacity: 1;
  }
</style>
<div class="card" id="gdplusbanner">
  <article class="banner">
    <div class="banner-box">
      <img src="https://assets-staging.plus.gamedistribution.com/game/images/Klondike/landing_page/lp_background.jpg"
        width="1500" height="1368" alt="">
    </div>
    <div class="banner-content">
      <!-- <p class="banner-tags">
        <span class="banner-tag">200%</span>
        <span class="banner-tag">Klondike</span>
      </p> -->

      <h1 class="banner-title">
        <div style="display: inline;" gdplusbannerlanguage="en"><span style="color:rgb(0, 0, 0)">Hi! Test! </span></div>
        <div style="display: none;" gdplusbannerlanguage="de"><span style="color:rgb(0, 0, 0)">Hallo!</span></div>
        <div style="display: none;" gdplusbannerlanguage="es"><span style="color:rgb(0, 0, 0)">Hola!</span></div>
        <div style="display: none;" gdplusbannerlanguage="fr"><span style="color:rgb(0, 0, 0)">Hey!</span></div>
        <div style="display: none;" gdplusbannerlanguage="it"><span style="color:rgb(0, 0, 0)">Ciao!</span></div>
        <div style="display: none;" gdplusbannerlanguage="nl"><span style="color:rgb(0, 0, 0)">Hallo!</span></div>
        <div style="display: none;" gdplusbannerlanguage="pl"><span style="color:rgb(0, 0, 0)">Witaj!</span></div>
        <div style="display: none;" gdplusbannerlanguage="pt"><span style="color:rgb(0, 0, 0)">Olá!</span></div>
      </h1>

      <p class="banner-desc">
        <div>
          <div style="display: inline;" gdplusbannerlanguage="en">Exclusively for your first purchase you will receive
            a
            bonus of <span
              style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span>!
            Check out the shop to see this amazing offer!</div>
          <div style="display: none;" gdplusbannerlanguage="de">Auf deinen ersten Einkauf bekommst Du heute einen
            Bonus
            von <span style="color:rgb(0, 0, 0);font-size:  1.2rem;font-weight: bold; line-height: 30px">+200%</span>!
            Schaue gleich mal im Shop nach!</div>
          <div style="display: none;" gdplusbannerlanguage="es">¡Solo por tu primera compra recibirás un bono de <span
              style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span>! ¡Echa un
            vistazo a la tienda para ver esta fantástica oferta!</div>
          <div style="display: none;" gdplusbannerlanguage="fr">Pour ton premier achat exclusivement, tu recevras un
            bonus
            de <span style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span> !
            Jette un coup d'oeil au magasin pour voir cette offre incroyable !</div>
          <div style="display: none;" gdplusbannerlanguage="it">Solo per il primo acquisto riceverai un bonus:<span
              style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span>! Dai
            un'occhiata a questa fantastica offerta nel negozio!</div>
          <div style="display: none;" gdplusbannerlanguage="nl">Alleen bij jouw eerste aankoop ontvang je een bonus
            van
            <span style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span>! Ga
            snel
            naar de winkel voor dit aanbod!
          </div>
          <div style="display: none;" gdplusbannerlanguage="pl">Przy pierwszym zakupie otrzymasz bonus w
            wysokości<span
              style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span>! Sprawdź
            teraz w sklepie!</div>
          <div style="display: none;" gdplusbannerlanguage="pt">Por sua primeira compra você irá receber um bônus
            de<span style="color:rgb(0, 0, 0);font-size: 1.2rem;font-weight: bold; line-height: 30px">+200%</span>!
            Confira essa
            oferta genial na loja!</div>
        </div>
      </p>

      <button class="banner-shop-button" id="gdplusbannershopbutton" type="button" onclick="window.gdplay.openShop()>
        <div style="display: inline;" gdplusbannerlanguage="en">TO THE SHOP</div>
        <div style="display: none;" gdplusbannerlanguage="de">ZUM LADEN</div>
        <div style="display: none;" gdplusbannerlanguage="es">TR A LA TIENDA</div>
        <div style="display: none;" gdplusbannerlanguage="fr">À LA BOUTIQUE</div>
        <div style="display: none;" gdplusbannerlanguage="it">AL NEGOZIO</div>
        <div style="display: none;" gdplusbannerlanguage="nl">NAAR DE WINKEL</div>
        <div style="display: none;" gdplusbannerlanguage="pl">DO SKLEPU</div>
        <div style="display: none;" gdplusbannerlanguage="pt">PARA A LOJA</div>
      </button>

    </div>
    <div class="banner-close-button" onclick="window.gdplay.closeBanner()">
    </div>
  </article>
</div>
<script type="text/javascript">
  var browserLanguage = (window.navigator.userLanguage || window.navigator.language).slice(0, 2);
  var banner = document.getElementById('gdplusbanner');
  var bannerString = banner.innerHTML;
  var button = document.getElementById('gdplusbannershopbutton');
  var buttonString = button.innerHTML;
  var browserLanguage = bannerString.indexOf('gdplusbannerlanguage="' + browserLanguage + '"') < 0 ? 'en' : browserLanguage;
  var re = new RegExp('style="display: inline;"', 'g');
  bannerString = bannerString.replace(re, 'style="display: none;"');
  var re = new RegExp('style="display: none;" gdplusbannerlanguage="' + browserLanguage + '"', 'g');
  bannerString = bannerString.replace(re, 'style="display: inline;" gdplusbannerlanguage="' + browserLanguage + '"');
  banner.innerHTML = bannerString;
</script>`;
